/* eslint-disable no-unused-expressions */
/* eslint-disable no-useless-call */
/* eslint-disable brace-style */
/* eslint-disable indent */
/* eslint-disable block-spacing */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
var OpenMode_ModalDial = 1
var OpenMode_Hidden = 2
var OpenMode_IFrame = 3
var OpenMode_NewWin = 4

export class eSpecif {
  constructor(nOpenMode) {
    this.OpenMode = nOpenMode
    switch (nOpenMode) {
      case OpenMode_ModalDial:
      case OpenMode_IFrame:
        this.Win = top
        break
      case OpenMode_NewWin:
        this.Win = window.opener
        break
    }
  }

  // Chargement d'une fiche event en mode intégré dans XRM
  LoadFile = function (nTab, nFileId) {
    this.Win.loadFile(nTab, nFileId)
  }

  // rafraichit la fiche en cours
  RefreshFile = function () {
    if (this.Win.getCurrentView() == 'FILE_MODIFICATION') this.Win.RefreshFile()
  }

  // Rafraichit la partie haute de la fiche
  RefreshFileHeader = function () {
    if (this.Win.getCurrentView() == 'FILE_MODIFICATION') {
      this.Win.RefreshHeader()
    }
  }

  // Rafraichit la liste en cours, peut également rafraichir l'affichage d'agenda
  RefreshList = function () {
    if (
      this.Win.getCurrentView() == 'LIST' ||
      this.Win.getCurrentView == 'CALENDAR' ||
      this.Win.getCurrentView == 'CALENDAR_LIST'
    ) {
      this.Win.ReloadList()
    }
  }

  // Charge la liste de l'onglet nTab
  // nTab : Table à charger
  // nFilterId : filtre à lancer (optionel)
  // cancelCurrentFilter : annule les filtres en cours  (optionel)
  LoadList = function (nTab, nFilterId, cancelCurrentFilter) {
    var myContext = this
    var MyFct = function () { }

    if (typeof nFilterId !== 'undefined' && nFilterId != null) {
      MyFct = function () {
        myContext.Win.updateUserPref(
          'tab=' + nTab + ';$;listfilterid=' + nFilterId,
          function () {
            myContext.Win.goTabList(nTab)
          }
        )
      }
    } else {
      MyFct = myContext.Win.goTabList(nTab)
    }

    if (typeof cancelCurrentFilter !== 'undefined' && cancelCurrentFilter) {
      var myCallBack = MyFct
      MyFct = function () {
        myContext.Win.updateUserPref(
          'tab=' + nTab + ';$;clearalltabfilter',
          myCallBack
        )
      }
    }

    MyFct()
  }

  // Rafraichit le signet donné
  RefreshBkm = function (nBkm) {
    if (this.Win.getCurrentView() == 'FILE_MODIFICATION') {
      this.Win.RefreshBkm(nBkm)
    }
  }

  // Rafraichit tous les signets affichés
  RefreshAllBkms = function () {
    if (this.Win.getCurrentView() == 'FILE_MODIFICATION') {
      this.Win.RefreshAllBkm()
    }
  }

  // Affiche une fiche template ou event dans une popup
  // Les boutons de validation ne seront pas disponibles.
  ShowFilePopup = function (nTab, nFileid, sLabel) {
    this.Win.shFileInPopup.apply(this.Win, [
      nTab,
      nFileid,
      sLabel,
      0,
      0,
      0,
      null,
      false,
      null,
      10
    ])
    // this.Win.shFileInPopup(nTab, nFileid, sLabel, 0, 0, 0, null, false, null, 10) ;
  }

  // ferme la modal de la spécif
  CloseModalSpecif = function () {
    if (this.OpenMode == OpenMode_ModalDial) {
      // récupération de la modal
      if (top.window['_md'] && window.name) {
        var myModal = top.window['_md']['specif_' + window.name]
        // on ferme
        if (myModal && myModal.isModalDialog && myModal.isSpecif) {
          myModal.hide()
        }
      }
    }
  }
}
